import { useCallback, useEffect, useState } from "react";

/**
 * Whole-second countdown. `start(n)` (re)starts it at n seconds; the returned
 * value reaches 0 when the countdown is over.
 */
const useCountdown = (): [number, (seconds: number) => void] => {
	const [secondsLeft, setSecondsLeft] = useState<number>(0);

	useEffect(() => {
		if (secondsLeft <= 0) return;
		const timer = setTimeout(() => {
			setSecondsLeft((previous) => Math.max(previous - 1, 0));
		}, 1000);
		return () => clearTimeout(timer);
	}, [secondsLeft]);

	const start = useCallback((seconds: number) => {
		setSecondsLeft(Math.max(Math.ceil(seconds), 0));
	}, []);

	return [secondsLeft, start];
};

export default useCountdown;
